import { observable, reaction } from "mobx"

import { devModeState } from "@/hooks/useDevMode.ts"
import { Model } from "@/lib/Model.ts"

import type { AiAgentTaskSettings } from "@/lib/client/generated/TypeDefinitions.ts"

export class TaskSettingsModel extends Model {
  readonly useBrowserVerification = observable.box(false)
  readonly mockForTesting = observable.box(false)
  readonly useMultiIterationLLMHistory = observable.box(false)
  readonly generateGuidelinesInOnboarding = observable.box(false)

  constructor(readonly isNewProject: boolean) {
    super("TaskSettingsModel")

    this.lifetime.add(reaction(() => devModeState.get(), (value) => {
      this.useMultiIterationLLMHistory.set(value)
      this.generateGuidelinesInOnboarding.set(value)
    }, { fireImmediately: true }), "TaskSettingsModel:listenToDevMode")
  }

  getSettings(): AiAgentTaskSettings {
    return {
      ...emptyAiAgentTaskSettings,
      useBrowserVerification: this.useBrowserVerification.get(),
      mockForTesting: this.mockForTesting.get(),
      useMultiIterationLLMHistory: this.useMultiIterationLLMHistory.get(),
      generateGuidelinesInOnboarding: this.isNewProject ? this.generateGuidelinesInOnboarding.get() : null,
    }
  }
}

const emptyAiAgentTaskSettings: AiAgentTaskSettings = {
  llmProfile: null,
  useCodeSearchWithEmbeddings: null,
  skipVerification: null,
  maxAgentIterationsCount: null,
  maxFixAttemptsCount: null,
  useRepoMap: null,
  viewFileWindowSize: null,
  maxSearchResults: null,
  useMemories: null,
  useBrowserVerification: null,
  useTodoList: null,
  mockForTesting: null,
  useMultiIterationLLMHistory: null,
  generateGuidelinesInOnboarding: null,
}
